import { render } from "./index.vue?vue&type=template&id=5b96c0d3&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5b96c0d3&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/open_acc_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b96c0d3"]])

export default __exports__